export type WebStorageKind = "local" | "session";

const STORAGE_AVAILABILITY_TEST_KEY = "modernizr";

function getWebStorage(storageKind: WebStorageKind): Storage {
  return storageKind === "local"
    ? globalThis.localStorage
    : globalThis.sessionStorage;
}

export function getWebStorageItem(
  storageKind: WebStorageKind,
  key: string
): string | null {
  try {
    return getWebStorage(storageKind).getItem(key);
  } catch {
    return null;
  }
}

export function setWebStorageItem(
  storageKind: WebStorageKind,
  key: string,
  value: string
): boolean {
  try {
    getWebStorage(storageKind).setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function removeWebStorageItem(
  storageKind: WebStorageKind,
  key: string
): boolean {
  try {
    getWebStorage(storageKind).removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function isWebStorageAvailable(storageKind: WebStorageKind): boolean {
  return (
    setWebStorageItem(
      storageKind,
      STORAGE_AVAILABILITY_TEST_KEY,
      STORAGE_AVAILABILITY_TEST_KEY
    ) && removeWebStorageItem(storageKind, STORAGE_AVAILABILITY_TEST_KEY)
  );
}
